module.exports = __webpack_public_path__ + "static/img/ent-detail-50.3dfa127.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-50.jpg
// module id = qV9G
// module chunks = 52